import { AdditionalStagesTypes, AdditionalStagesAction, AdditionalStage } from '../types';

export function getList(
    additionalStages: AdditionalStage[],
): AdditionalStagesAction<{ additionalStages: AdditionalStage[] }> {
    return {
        type: AdditionalStagesTypes.GET_LIST,
        payload: { additionalStages },
    };
}

export function requestGetAdditionalStagesList() {
    return {
        type: AdditionalStagesTypes.REQUEST_GET_LIST,
    };
}

export function requestSaveAdditionalStage(
    additionalStage: AdditionalStage,
): AdditionalStagesAction<{ additionalStage: AdditionalStage }> {
    return {
        type: AdditionalStagesTypes.REQUEST_SAVE_ADDITIONAL_STAGE,
        payload: { additionalStage },
    };
}

export function saveAdditionalStage(
    additionalStage?: AdditionalStage,
): AdditionalStagesAction<{ additionalStage?: AdditionalStage }> {
    return {
        type: AdditionalStagesTypes.SAVE_ADDITIONAL_STAGE,
        payload: { additionalStage },
    };
}
